import PropTypes from "prop-types";
import React from "react";

const ICON_BADGE_FG_DESIGN_TOKEN = "cmp-core-color-icon-badge-fg";

/**
 * IconBadge renders a circle on an icon.
 */
export const IconBadge = (props) => {
  const { badge, fill = `var(--${ICON_BADGE_FG_DESIGN_TOKEN})`, viewBox } = props;
  const [minX, minY, width] = viewBox.split(" ");
  const radius = 5;

  return badge > 0 ? <circle r={radius} cx={getCX()} cy={getCY()} fill={fill} /> : null;

  function getCX() {
    return parseInt(width) + parseInt(minX) - radius;
  }

  function getCY() {
    return parseInt(minY) + radius;
  }
};

IconBadge.displayName = "IconBadge";

IconBadge.propTypes = {
  /** The number of items that are represented by the badge */
  badge: PropTypes.number,

  /** The fill color to use on the badge */
  fill: PropTypes.string,

  /** The viewbox of the icon containing the icon badge */
  viewBox: PropTypes.string,
};
